import Archive from './archive';
import CopyProgram from './copyProgram';
import DeleteProgram from './deleteProgram';
import EditProgram from './editProgram';
import Unarchive from './unarchive';

import { ProgramDataProperties } from '../../../../../redux/API/ClientAPIHelpers/clientProgramProperties';

const Actions = ({ data }: { data: ProgramDataProperties }) => (
	<>
		<EditProgram data={data} />
		<CopyProgram data={data} />
		{data.isArchived ? <Unarchive data={data} /> : <Archive data={data} />}
		<DeleteProgram data={data} />
	</>
);

export default Actions;
